var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgA7F7A9592672Dc8292B64Fc8B2835B0D8Bc8D3Fda03C89B24078F79B1Ba85C61(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6.25C8.75 7.63071 7.63071 8.75 6.25 8.75C4.86929 8.75 3.75 7.63071 3.75 6.25C3.75 4.86929 4.86929 3.75 6.25 3.75C7.63071 3.75 8.75 4.86929 8.75 6.25Z",
    fill: "#424143"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.25C17.5 7.63071 16.3807 8.75 15 8.75C13.6193 8.75 12.5 7.63071 12.5 6.25C12.5 4.86929 13.6193 3.75 15 3.75C16.3807 3.75 17.5 4.86929 17.5 6.25Z",
    fill: "#424143"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 8.75C25.1307 8.75 26.25 7.63071 26.25 6.25C26.25 4.86929 25.1307 3.75 23.75 3.75C22.3693 3.75 21.25 4.86929 21.25 6.25C21.25 7.63071 22.3693 8.75 23.75 8.75Z",
    fill: "#424143"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 15C8.75 16.3807 7.63071 17.5 6.25 17.5C4.86929 17.5 3.75 16.3807 3.75 15C3.75 13.6193 4.86929 12.5 6.25 12.5C7.63071 12.5 8.75 13.6193 8.75 15Z",
    fill: "#424143"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.5C16.3807 17.5 17.5 16.3807 17.5 15C17.5 13.6193 16.3807 12.5 15 12.5C13.6193 12.5 12.5 13.6193 12.5 15C12.5 16.3807 13.6193 17.5 15 17.5Z",
    fill: "#424143"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 15C26.25 16.3807 25.1307 17.5 23.75 17.5C22.3693 17.5 21.25 16.3807 21.25 15C21.25 13.6193 22.3693 12.5 23.75 12.5C25.1307 12.5 26.25 13.6193 26.25 15Z",
    fill: "#424143"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 26.25C7.63071 26.25 8.75 25.1307 8.75 23.75C8.75 22.3693 7.63071 21.25 6.25 21.25C4.86929 21.25 3.75 22.3693 3.75 23.75C3.75 25.1307 4.86929 26.25 6.25 26.25Z",
    fill: "#424143"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 23.75C17.5 25.1307 16.3807 26.25 15 26.25C13.6193 26.25 12.5 25.1307 12.5 23.75C12.5 22.3693 13.6193 21.25 15 21.25C16.3807 21.25 17.5 22.3693 17.5 23.75Z",
    fill: "#424143"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 26.25C25.1307 26.25 26.25 25.1307 26.25 23.75C26.25 22.3693 25.1307 21.25 23.75 21.25C22.3693 21.25 21.25 22.3693 21.25 23.75C21.25 25.1307 22.3693 26.25 23.75 26.25Z",
    fill: "#424143"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA7F7A9592672Dc8292B64Fc8B2835B0D8Bc8D3Fda03C89B24078F79B1Ba85C61);
export default __webpack_public_path__ + "static/media/a7f7a9592672dc8292b64fc8b2835b0d8bc8d3fda03c89b24078f79b1ba85c61.a58a0b9cae20f8846ce8d8f785130a97.svg";
export { ForwardRef as ReactComponent };